// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5cf0f2b6","453":"402f53e3","667":"f84d3b97"}[chunkId] + ".chunk.js";
};